import { fromJS } from 'immutable';
import {
	ACCOUNT_MANAGERS_CHANGED,
	ACCOUNTS_CHANGED, ARCS_CHANGED,
	BEACONS_CHANGED,
	BILLING_CYCLE_CHANGED,
	CHANGE_LAYOUT,
	DEVICE_CHANGED,
	DEVICES_CHANGED, GEOFENCES_CHANGED,
	GET_ACCOUNTS,
	GET_DEVICES,
	LAYOUT_NO_CONSOLE,
	PROMS_CHANGED,
	SET_DEVICE_FILTER,
	SET_SELECTED_ACCOUNT, SET_SHOW_WIKI, SET_V4_SEARCH, SIM_CARDS_CHANGED,
	SITES_CHANGED, TEAMS_CHANGED, V4_SEARCH_SETTLED,
	WS_DATA_DEVICE_COUNTS, WS_DATA_SIM_CARDS,
} from './constants';
import { AUTH_SUCCESS } from '../LoginPage/constants';
import { SET_DEVICE_AVAILABILITY, SET_DEVICE_ONLINE, WS_DATA_DEVICE } from '../../redux/constants/device.constants';
import { applyStatusAction } from '../../redux/reducers/device.reducer';
import dayjs from 'dayjs';
import Device from '../../utils/models/Device';
import SimCard from "../../utils/models/SimCard";
import {V4SearchEntity} from "../../utils/v4Search";

let layout = localStorage.getItem(CHANGE_LAYOUT);
layout = parseInt(layout === null ? LAYOUT_NO_CONSOLE : layout);

export const initialState = fromJS({
	selectedAccount: null,
	accounts: [],
	accountManagers: [],
	customers: [],
	devices: [],
	proms: [],
	beacons: [],
	geofences: [],
	teams: [],
	sites: [],
	simCards: [],
	arcs: [],
	arcsFetched: false,
	billingCycle: dayjs(),
	layout,
	devicesFetched: false,
	simCardsFetched: false,
	accountsFetched: false,
	deviceFilter: '',
	// {entity, term, hasMore, failed}; selectedAccount stays, hidden, until it ends.
	v4Search: null,
	deviceCounts: {},
	showWiki: ''
});

function adminReducer(state: Map = initialState, action) {
	const newDevices = state.get('devices');
	switch (action.type) {
		case AUTH_SUCCESS:
			return initialState;
		case BILLING_CYCLE_CHANGED:
			return state.set('billingCycle', action.billingCycle);
		case PROMS_CHANGED:
			return state.set('proms', action.proms);
		case ARCS_CHANGED:
			return state.set('arcs', action.arcs).set('arcsFetched', true);
		case ACCOUNT_MANAGERS_CHANGED:
			return state.set('accountManagers', action.accountManagers);
		case ACCOUNTS_CHANGED:
			return state.set('accounts', action.accounts).set('accountsFetched', true);
		case GET_ACCOUNTS:
			return state.set('accountsFetched', false);
		case DEVICES_CHANGED:
			return state.set('devices', action.devices).set('devicesFetched', true);
		case WS_DATA_SIM_CARDS:
			action.simCards = action.data.map(s => new SimCard(s)); // eslint-disable-next-line
			return state.set('simCards', action.simCards).set('simCardsFetched', true);
		case SIM_CARDS_CHANGED:
			return state.set('simCards', action.simCards).set('simCardsFetched', true);
		case DEVICE_CHANGED:
			return state.set('devices', newDevices.filter(d => !!d).map(d => d.id === action.device.id ? action.device : d));
		case GET_DEVICES:
			return state.set('devicesFetched', false);
		case WS_DATA_DEVICE:
			if(!action.data) return state;
			const add = !state.get('devices').find(d => +d.id === action.data.id);
			if(add && state.get('deviceFilter')) return state;
			if(add) newDevices.push(new Device(action.data));
			if(!add) return state;
			return state.set('devices', newDevices.filter(d => !!d).map(d => d.id === action.data.id ? new Device(action.data) : d));
		// The grid holds its own copy of each V4 row.
		case SET_DEVICE_ONLINE:
		case SET_DEVICE_AVAILABILITY:
			return state.set('devices', applyStatusAction(newDevices, action));
		case BEACONS_CHANGED:
			return state.set('beacons', action.beacons);
		case TEAMS_CHANGED:
			return state.set('teams', action.teams);
		case GEOFENCES_CHANGED:
			return state.set('geofences', action.geofences);
		case SITES_CHANGED:
			return state.set('sites', action.sites);
		case SET_SELECTED_ACCOUNT:
			return state.set('selectedAccount', action.account).set('v4Search', null);
		case SET_V4_SEARCH: {
			if (action.term === null) {
				return state.get('v4Search')?.entity === action.entity ? state.set('v4Search', null) : state;
			}
			const searching = state.set('v4Search', {entity: action.entity, term: action.term, hasMore: false, failed: false});
			// The device grid spins on this flag.
			return action.entity === V4SearchEntity.Devices ? searching.set('devicesFetched', false) : searching;
		}
		case V4_SEARCH_SETTLED: {
			const search = state.get('v4Search');
			if (search?.entity !== action.entity || search.term !== action.term) return state;
			return state.set('v4Search', {...search, hasMore: action.hasMore, failed: action.failed});
		}
		case CHANGE_LAYOUT:
			return state.set('layout', action.layout);
		case SET_DEVICE_FILTER:
			return state.set('deviceFilter', action.filter);
		case WS_DATA_DEVICE_COUNTS:
			return state.set('deviceCounts', action.data);
		case SET_SHOW_WIKI:
			return state.set('showWiki', !!action.show);
		default: return state;
	}
}

export default adminReducer;
